import { mode } from "@chakra-ui/theme-tools";

export const FORUM = {
  tlo: "#161719",
  panel: "#1D1F25",
  panelJasny: "#22242A",
  plakietka: "#25272F",
  przycisk: "#2F3033",
  tekst: "#E3E3E3",
  tekstPrzygaszony: "#878787",
  tekstJasny: "#FFFFFF",
  zielen: "#2C8C69",
  granat: "#2E3A5C",
  czerwien: "#C53030",
  bursztyn: "#DD6B20",
  obramowanie: "rgba(255, 255, 255, 0.06)",
};

export const TRANSITION = "all 0.3s linear";

export const globalStyles = {
  colors: {
    forum: {
      tlo: FORUM.tlo,
      panel: FORUM.panel,
      panelJasny: FORUM.panelJasny,
      plakietka: FORUM.plakietka,
      przycisk: FORUM.przycisk,
      tekst: FORUM.tekst,
      przygaszony: FORUM.tekstPrzygaszony,
      zielen: FORUM.zielen,
      granat: FORUM.granat,
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1b254b",
      800: "#111c44",
      900: "#0b1437",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        color: FORUM.tekst,
        fontFamily: "Inter, 'Noto Sans', sans-serif",
        bg: mode("gray.50", FORUM.tlo)(props),
        backgroundImage: "url('/tlo-forum.png')",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "0 0",
      },
      html: {
        fontFamily: "Inter, 'Noto Sans', sans-serif",
      },
      "::-webkit-scrollbar": { width: "6px", height: "6px" },
      "::-webkit-scrollbar-track": { background: "transparent" },
      "::-webkit-scrollbar-thumb": {
        background: "rgba(255,255,255,0.10)",
        borderRadius: "30px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "rgba(255,255,255,0.20)",
      },
      "@keyframes rainbow": {
        "0%": { filter: "hue-rotate(0deg)" },
        "100%": { filter: "hue-rotate(360deg)" },
      },
      "body.rainbow #root": {
        animation: "rainbow 12s linear infinite",
      },
      "@media (max-width: 48em)": {
        "input, textarea, select": { fontSize: "16px !important" },
      },
      ".loading-icon": {
        animation: "spin 1s linear infinite",
      },
      "@keyframes spin": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" },
      },
    }),
  },
};
